import * as actorSchema from "#schema";

export { actorRelations } from "#relations";
export type {
  Collection,
  CollectionMorpheme,
  FsrsCard,
  FsrsCardReviewLog,
  MorphemeNote,
  MorphemeSearchVisit,
  User,
  UserCard,
  UserCardReview,
  UserGraphemeMeaningCard,
  UserGraphemePronunciationCard,
  UserQuizCard,
  UserSentence,
  UserSlide,
  UserWord,
  UserWordSentenceCard,
  WordCardKind,
} from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables";
export type { UserQuest } from "#user-quest-table";
export type { RewardClaim } from "#reward-claim-table";
export type { TravelTrip } from "#travel-trip-table";
export { WORD_CARD_KIND_LIST } from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables";

export type ActorTables = {
  [$Key in keyof typeof actorSchema]: (typeof actorSchema)[$Key]["$inferSelect"][];
};

/**
 * Narrow subset of {@link ActorTables} surfaced through `ActorDatabaseContext`.
 * This is the seeded singleton `user[0]` row (which now carries the per-user
 * settings columns too) that `useActorContextValue` reads to compose
 * app-wide settings before any screen renders. Every other table is
 * leaf-subscribed via per-table `useQuery` hooks in the consuming component or
 * hook.
 */
export type ActorContextTables = Pick<ActorTables, "user">;
